import React, { useState } from "react";
import Footer from "./Footer";
import Nav from "./Nav";
import StoryCard from "./StoryCard";
import customerStoriesData from "../data/customerStories";
import { usersDataModal } from "../atoms/atom";
import { useRecoilState } from "recoil";

const CustomerStories = () => {
  const [data, setData] = useRecoilState(usersDataModal);
  console.log("data", data);

  return (
    <div>
      <Nav active="customerStories" />
      <div className="bg-[#f4f8f9] pb-16">
        <div
          // data-aos="fade-up"
          // data-aos-delay="200"
          // data-aos-duration="1000"
          className=" max-w-[1000px] mx-auto px-5 pt-8 pb-20"
        >
          <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#323a41] mt-3">
            Case Studies
          </h1>
          <p className="mt-5 md:text-[23px] max-w-[880px] mx-auto text-[18px] leading-9 text-[#52626f]  text-center opacity-80">
            {`Learn how Video Husky removes the stress of editing by hearing from customers who’ve used our service.`}
          </p>
        </div>

        <div className="max-w-[1320px] mx-auto flex flex-wrap items-center justify-around xl:justify-between">
          {customerStoriesData.map((item, index) => {
            return (
              <StoryCard
                from="customerStories"
                key={index}
                heading={item.heading}
                description={item.description1}
                img={item.img}
                click={() => {
                  setData(item);
                }}
              />
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CustomerStories;
